import { useState } from 'react';
import { login } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { useUser } from '../context/UserContext';

function LoginPage() {
  //const [user_id, setUserId] = useState();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setUser } = useUser();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault(); // ✅ evita el refresh

    try {

      const userData = await login(email, password);

      if (!userData || !userData.access_token) {
        throw new Error('Token no recibido');
      }

      localStorage.setItem('authToken', userData.access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);

      //console.log('Token guardado:', localStorage.getItem('authToken'));
      //console.log('Login exitoso:', userData);

      setTimeout(() => {
        navigate('/contacts');
      }, 0);
    } catch (error) {
      console.error('Error en login:', error);
      setError('Credenciales inválidas');
    }
  };

  /*
  const handleLogin = async () => {
    try {
      const userData = await login(email, password);

      if (!userData || !userData.access_token) {
        throw new Error('Token no recibido');
      }

      localStorage.setItem('authToken', userData.access_token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData); // ← actualiza el contexto

      console.log(localStorage.getItem('authToken'));
      console.log('Login exitoso:', userData);

      // Espera un ciclo de render para asegurar que el contexto se actualice
      setTimeout(() => {
        navigate('/contacts');
      }, 0);
    } catch (error) {
      console.error('Error en login:', error);
    }
  };
  */
  /*
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { access_token, user } = await login(email, password);

      localStorage.setItem('authToken', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/contacts');
    } catch (err) {
      setError('Credenciales inválidas');
    }
  };
  */

  return (
    <Container className="mt-5" style={{ maxWidth: '400px' }}>
      <h2>Iniciar sesión</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleLogin}>
        <Form.Group className="mb-3">
          <Form.Label>Correo</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" variant="primary" className="w-100">
          Entrar
        </Button>
      </Form>
    </Container>
  );
}

export default LoginPage;